import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'vq-checkboxes',
  templateUrl: './form-checkboxes.component.html',
  styleUrls: []
})
export class FormCheckboxesComponent implements OnInit {

  @Input('vqModel') model:Array<any>;
  @Input('vqLabel') label:string;
  @Input('vqErrors') errors:Array<string> = [];
  @Input('vqHelpText') helpText:string;
  @Input('vqLabelGetter') labelGetter:any = this._defaultLabelGetter;
  @Input('vqValueGetter') valueGetter:any = this._defaultValueGetter;
  @Input('vqOptions') options:Array<string> = [];
  @Input('vqApiService') apiService:any;
  @Input('vqFilter') filter:any;

  @Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();

  id:string;
  transModel :Array<any> = [];

  constructor(
    private _api:ApiService
    ) { }

  ngOnInit() {
    this._getOptions();
    // this._initModel();
  }

  private _defaultLabelGetter(o:any):any {
    return o;
  }

  private _defaultValueGetter(o:any):any {
    return o;
  }

  private _resolveValue(obj:any, attr:string):any {
    return attr.split('.').reduce(function(prev, curr) {
        // return prev[curr] ? prev[curr] : prev;
        return prev[curr];
    }, obj)
  }

  private _isString(v) {
    return typeof v === 'string';
  }

  public getLabel(a) {
    if (this._isString(this.labelGetter)) {
      return this._resolveValue(a, this.labelGetter);
    } else {
      return this.labelGetter(a);
    }
  }

  public getValue(a) {
    if (this._isString(this.valueGetter)) {
      return this._resolveValue(a, this.valueGetter);
    } else {
      return this.valueGetter(a);
    }
  }

  public isChecked(o) {
  	let value = this.getValue(o);
  	return this.model.indexOf(value) > -1;
  }

  public change(o:any, $event) {
    let value = this.getValue(o);
    if(!this._isString(this.model)){
    	let index = this.model.indexOf(value);
    	if (index > -1) {
    		this.model.splice(index, 1);
    	} else {
    		this.model.push(value);
    	}
    	// copy model to force change detection
    	this.model = [...this.model];
    }else{
      let index = this.transModel.indexOf(value);
      if (index > -1) {
        this.transModel.splice(index, 1);
      } else {
        this.transModel.push(value);
      }
      this.model = [parseInt(this.transModel.join(''))];
    }
  	this.modelChange.emit(this.model);
  }

  private _getOptions() {
    if (!this.options || (this.options && this.options.length == 0)) {
      this._api[this.apiService].list(this.filter).subscribe((v) => {
        this.options = v.results;
      })
    }
  }

  public hasError() {
    return (this.errors && this.errors.length > 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-checkboxes/form-checkboxes.component.ts